(ns com.theplantscape.web-ui.tailwind.form.elements.form
  (:require [com.theplantscape.web-ui.error-boudary :refer [error-boundary-component]]))

(defn get-form-value [value-atom key]
  (get-in @value-atom [:values key]))

(defn set-form-value [value-atom key new-value]
  (swap! value-atom assoc-in [:values key] new-value))

(defn set-form-value-event [value-atom key new-value]
  (swap! value-atom assoc-in [:values key] 
         (case (-> new-value .-target .-type)
           "checkbox" (if (-> new-value .-target .-checked) (-> new-value .-target .-defaultValue) nil)
           (-> new-value .-target .-value)
           ))
  )

(defn form [cfg body]
  [error-boundary-component 
   [:form cfg body]])
